var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPressInc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 51,
    width: 93,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.591 25.988l-8.962.992c-.125-2.48-.623-5.084-3.673-5.084-3.778 0-4.155 3.091-4.17 6.072v.252c0 3.1.311 6.262 4.17 6.262 2.054 0 3.797-1.178 3.797-3.596h8.963l-.063.744C83.16 38.884 76.624 40 71.894 40c-7.407 0-14.689-3.658-14.689-11.842s7.282-11.842 14.69-11.842l.012-.001c.443-.027 11.59-.509 12.684 9.673zm3.112 6.014c1.01-.007 1.979.39 2.692 1.1s1.112 1.677 1.105 2.682c0 1.53-.925 2.909-2.344 3.494a3.807 3.807 0 01-4.137-.82 3.771 3.771 0 01-.823-4.121 3.797 3.797 0 013.507-2.335zm-50.726-15.81v4.588l.623-.62c2.427-2.728 5.166-3.72 8.713-3.72 5.042 0 9.15 2.046 9.15 7.626v8.804h2.676v6.634H41.894v-6.696h3.112v-6.944c0-2.108-1.494-3.038-3.423-3.038a4.185 4.185 0 00-3.05 1.195 4.152 4.152 0 00-1.245 3.021v5.766h3.175v6.634H23.844v-6.634h2.988v-9.982h-2.988v-6.634zM22.724 9v7.13h-3.983v16.678h3.983v6.634H1.5v-6.634h3.983V16.13H1.5V9z",
    fill: "#fff"
  })));
}

export default SvgPressInc;